import _ from 'lodash';
import { cardShape } from '@editor/droplets/utils';

export default function cardsGeneral() {
  return {
    _id: false,
    type: 'droplet.cardsGeneral',
    cards: _.times(2, cardShape({ type: 'droplet.cardsGeneral.cardItem' })),
    mediaQueries: [
      {
        selector: '.drzCard-general-titleSection',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    firstDrop: false,
    activeCard: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-general/droplet.schema.js